import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-tailwind/react";
import SignIn from "./features/user/SignIn";
import ErrorPage from "./pages/ErrorPage";
import { AuthProvider } from "./context/AuthProvider";
import RequiredAuth from "./components/Authorization/RequiredAuth";
import Unauthorized from "./pages/Unauthorized";
import Appraisal from "./features/appraisal/Appraisal";
import Template from "./features/template/Template";
import Employee from "./features/employee/Employee";
import AppraisalReview from "./features/appraisal/AppraisalReview";
import SignUp from "./features/user/SignUp";
import EmployeeProfile from "./features/employee/EmployeeProfile";
import SelfAppraisal from "./features/appraisal/SelfAppraisal";
import EmployeePerformance from "./features/employee/EmployeePerformance";
import Designation from "./features/designation/Designation";
import Department from "./features/department/department";
import { ROLES } from "./uitls/Utils";
import AddEditEmployee from "./features/employee/AddEditEmployee";
import EmployeeGeneratedAppraisals from "./features/appraisal/EmployeeGeneratedAppraisals";
import ManagerReviewedAppraisals from "./features/appraisal/ManagerReviewedAppraisals";
import DashboardWrapper from "./features/dashboard/DashboardWrapper";
import AddEditTemplate from "./features/template/AddEditTemplate";
import ForgotPassword from "./features/user/ForgotPassword";
import ResetPassword from "./features/user/ResetPassword";
import EmployeePassword from "./features/employee/EmployeePassword";
import EmployeeResetPassword from "./features/employee/EmployeeResetPassword";
import ChangePassword from "./features/user/ChangePassword";
import UpdatePassword from "./features/user/UpdatePassword";
import MfaSetup from "./features/user/MfaSetup";
import MgrDashboard from "./features/dashboard/MgrDashboard";
import ViewManagerAppraisal from "./features/appraisal/ViewManagerAppraisal";
import UpdateManagerAppraisal from "./features/appraisal/UpdateManagerAppraisal";
import ReviewAppraisal from "./features/appraisal/ReviewAppraisal";
import AddEditAssignTemplate from "./features/template/AddEditAssignTemplate";
import AssignTemplate from "./features/template/AssignTemplate";
import EmpAssignedAppraisal from "./features/appraisal/EmpAssignedAppraisal";
import ManagerAssignedAppraisal from "./features/appraisal/ManagerAssignedAppraisal";
import AddUpdateManagerSelfAppraisal from "./features/appraisal/AddUpdateManagerSelfAppraisal";
import ManagerEmployee from "./features/employee/ManagerEmployee";
import "react-datepicker/dist/react-datepicker.css";
import EmpDashBoard from "./features/dashboard/EmpDashBoard";
const customTheme = {
  dialog: {
    styles: {
      base: {
        backdrop: {
          display: "grid",
          placeItems: "place-items-center",
          position: "fixed",
          top: 0,

          left: 0,
          width: "w-screen",
          height: "h-screen",
          backgroundColor: "bg-transparent",
          backgroundOpacity: "bg-opacity-60",
          backdropFilter: "backdrop-blur-xs",
        },
      },
    },
  },
};


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <SignIn />,
      },
      {
        path: "/signIn",
        element: <SignIn />,
      },
      // {
      //   path: "/signUp",
      //   element: <SignUp />,
      // },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/change-password",
        element: <ChangePassword />,
      },
      {
        path: "/update-user-password",
        element: <UpdatePassword />,
      },
      {
        path: "/mfa-setup",
        element: <MfaSetup />,
      },
        {
        path: "/error",
        element: <ErrorPage />, 
      },
      {
        path: "/user-profile",
        element: <RequiredAuth allowedRoles={Object.values(ROLES)} />,
        children: [{ path: "/user-profile", element: <EmployeeProfile /> }],
      },
      {
        path: "/user-password",
        element: <RequiredAuth allowedRoles={Object.values(ROLES)} />,
        children: [{ path: "/user-password", element: <EmployeePassword /> }],
      },
      {
        path: "/user-reset-password",
        element: <RequiredAuth allowedRoles={Object.values(ROLES)} />,
        children: [
          { path: "/user-reset-password", element: <EmployeeResetPassword /> },
        ],
      },
      {
        path: "/account-settings",
        element: <RequiredAuth allowedRoles={Object.values(ROLES)} />,
        children: [
          { path: "/account-settings", element: <div>Account_Settings</div> },
        ],
      },
      {
        path: "/admin",
        element: <RequiredAuth allowedRoles={[ROLES.admin]} />,
        children: [
          { path: "/admin/dashboard", element: <DashboardWrapper /> },
          { path: "/admin/create-appraisal", element: <Appraisal /> },
          { path: "/admin/template", element: <Template /> },
          { path: "/admin/assign-template", element: <AssignTemplate /> },
          {
            path: "/admin/assign-template/add-update",
            element: <AddEditAssignTemplate />,
          },
          { path: "/admin/template/add-update", element: <AddEditTemplate /> },
          { path: "/admin/employee", element: <Employee /> },
          { path: "/admin/employee/add-update", element: <AddEditEmployee /> },

          { path: "/admin/business-unit", element: <Department /> },
          { path: "/admin/job-title", element: <Designation /> },
          { path: "/admin/all-appraisals", element: <AppraisalReview /> },
          { path: "/admin/review-final-appraisal", element: <SelfAppraisal /> },
        ],
      },
      {
        path: "/mgr",
        element: <RequiredAuth allowedRoles={[ROLES.mgr]} />,
        children: [
          { path: "/mgr/dashboard", element: <MgrDashboard /> },
          { path: "/mgr/employee", element: <ManagerEmployee /> },
         { path: "/mgr/all-appraisals", element: <AppraisalReview /> },
          { path: "/mgr/view-appraisals", element: <ViewManagerAppraisal /> },
          {
            path: "/mgr/manager-self-appraisal",
            element: <ManagerAssignedAppraisal />,
          },
          {
            path: "/mgr/manage-manager-self-appraisal",
            element: <AddUpdateManagerSelfAppraisal />,
          },

          {
            path: "/mgr/update-appraisals",
            element: <UpdateManagerAppraisal />,
          },
          {
            path: "/mgr/review-appraisals",
            element: <ReviewAppraisal />,
          },

          {
            path: "/mgr/self-appraisals",
            element: <EmpAssignedAppraisal />,
          },
          {
            path: "/mgr/employee-appraisals",
            element: <EmployeeGeneratedAppraisals />,
          },
          {
          path: "/mgr/reviewed-appraisals",
            element: <ManagerReviewedAppraisals />,
          },
          { path: "/mgr/view-appraisal", element: <EmpAssignedAppraisal /> },//employee
          { path: "/mgr/create-appraisal", element: <SelfAppraisal /> },
          { path: "/mgr/self-appraisal", element: <EmpAssignedAppraisal /> }, //self 
        ],
      },
      // {
      //   path: "/hr",
      //   element: <RequiredAuth allowedRoles={[ROLES.hr]} />,
      //   children: [
      //     { path: "/hr/dashboard", element: <div>HR_DashBoard</div> },
      //     { path: "/hr/create-appraisal", element: <SelfAppraisal /> },
      //     { path: "/hr/view-appraisal", element: <EmpAssignedAppraisal /> },
      //   ],
      // },
      {
        path: "/emp",
        element: <RequiredAuth allowedRoles={[ROLES.emp]} />,
        children: [
          { path: "/emp/dashboard", element: <EmpDashBoard /> },
          {
            path: "/emp/performance",
            element: <EmployeePerformance />,
          },
          { path: "/emp/profile", element: <EmployeeProfile /> },
          { path: "/emp/create-appraisal", element: <SelfAppraisal /> },
          // { path: "/emp/view-appraisal", element: <EmpAssignedAppraisal /> },
           { path: "/emp/self-appraisal", element: <EmpAssignedAppraisal /> },
        ],
      },
    ],
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />,
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AuthProvider>
      <ThemeProvider value={customTheme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </AuthProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
